import { useDispatch, useSelector } from 'react-redux'
import { soundex } from 'soundex-code'
import { selectAddressCurrentContractActive } from '../../SubscriptionForm/SubscriptionFormSelectors'
import { updateElectricityMeterAddressData } from '../../SubscriptionForm/SubscriptionFormSlice'
import { useTranslation } from 'react-i18next'

const useMeterOwnerRule = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { electricityMeter = {}, id } = useSelector(selectAddressCurrentContractActive)
  const { showPdlConfirmation } = electricityMeter

  const handleConfirmPdl = () => {
    dispatch(
      updateElectricityMeterAddressData({
        data: { showPdlConfirmation: false },
        id,
      }),
    )
  }

  const checkMeterOwner = (addressId, prestationType, enedisAuth, oldOccupant, lastName) => {
    if (!enedisAuth) {
      return
    }
    if (prestationType !== 'cdf') {
      dispatch(
        updateElectricityMeterAddressData({
          data: { showPdlConfirmation: false },
          id: addressId,
        }),
      )
      return
    }
    // todo-v2: if does not match block sale sending and activate again on confirmation clicked
    if (prestationType === 'cdf' && oldOccupant && lastName) {
      const splitOldOccupant = oldOccupant.split(' ')
      if (splitOldOccupant.length > 0) {
        const oldName = splitOldOccupant[0]
        if (soundex(lastName) !== soundex(oldName)) {
          dispatch(
            updateElectricityMeterAddressData({
              data: { showPdlConfirmation: true },
              id: addressId,
            }),
          )
        }
      }
    }
  }

  return {
    checkMeterOwner,
    handleConfirmPdl,
    showPdlConfirmation,
    t,
  }
}

export default useMeterOwnerRule
